<template>
  <div
    class="bbp-tabs"
    :class="[
      'bbp-tabs',
      isSmall && 'bbp-tabs_small'
    ]"
  >
    <template v-for="tab in tabsList">
      <div
        :key="tab.id"
        class="bbp-tabs__item"
        :class="{'bbp-tabs__item_active' : activeTab === tab.id}"
        @click="setActiveTab(tab)"
      >
        {{ tab.title }}
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BBPTabs',
  props: {
    tabsList: {
      type: Array,
      default: () => ([])
    },
    activeTab: {
      type: Number,
      default: 1
    },
    isSmall: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setActiveTab ({id}) {
      this.$emit('update:activeTab', id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bbp-tabs {
    display: flex;
    align-items: center;
    width: 100%;
    height: 54px;
    background: $color-white;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin: 0 0 6px 0;
    border-bottom: 3px solid $color-alabaster;

    &__item {
      padding: 18px 26px 18px 26px;
      color: $color-accent;
      font-size: 15px;
      font-weight: 600;
      line-height: 18px;
      position: relative;
      cursor: pointer;
      margin: 0 32px 0 0;

      &:last-child {
        margin: 0 0 0 0;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 0;
        width: 100%;
        border-radius: 3px 4px 0 0;
        background-color: $color-accent;
        transition: 0.3s;
        opacity: 0;
        height: 0;
      }

      &_active {
        pointer-events: none;

        &:after {
          opacity: 1;
          height: 3px;
        }
      }

      &:hover {
        &:after {
          background-color: $color-accent-hover;
          opacity: 1;
          height: 3px;
        }
      }
    }
  }

  .bbp-tabs_small {
    height: 27px;

    .bbp-tabs__item {
      padding: 2px 8px 8px 8px;
      font-size: 13px;
      line-height: 16px;
      margin: 0 14px 0 0;

      &:last-child {
        margin: 0 0 0 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTabs/BBPTabs.vue